import { inject } from '@angular/core';
import { Auth, authState } from '@angular/fire/auth';
import { CanActivateFn } from '@angular/router';

import { of } from 'rxjs';
import { first, switchMap } from 'rxjs/operators';

import { DashboardService } from '../services';

// eslint-disable-next-line func-style
export const loginGuard: CanActivateFn = () => {
  const dashboardService = inject(DashboardService);
  return authState(inject(Auth)).pipe(
    first(),
    switchMap((user) => {
      if (!user) {
        return of(true);
      } else {
        dashboardService.goToDashboard();
        return of(false);
      }
    }),
  );
};
